import type { PlatformRequestConfig } from 'Models/uiConfig/requestConfig';

import { makeGetLocalPreselectionFromBreadcrumbs } from '../common';

const requestConfig: PlatformRequestConfig = {
  getLocalPreselection: makeGetLocalPreselectionFromBreadcrumbs(
    '.breadcrumbs a, .breadcrumnb li, .breadcrumb a',
    { category: 'Category', brand: 'Manufacturer' },
    (...elements) =>
      elements
        .map((elem) => {
          const text = ((elem instanceof HTMLElement ? elem.innerText : elem.textContent) || '').trim();
          const ignore =
            elem.id === 'catCrumbHomeLink' || text === 'Home' || elem.getAttribute('data-cm-ignore');
          return !ignore && text;
        })
        .filter((x): x is string => Boolean(x)),
  ),
  pageUriParam: 'pageNumber',
};

export default requestConfig;
